import { IHistoryItem } from '_/common/history/history.types';
import { IReadme, IReadmeVersion } from '_/common/types/readme.types';
import { formatWrittenDate } from '_/utils/dateUtils';

export const readmeHistoryAdapter = (versions: IHistoryItem<IReadme>[]): IReadmeVersion[] => {
  // Sort versions by timestamp DESC (most recent first) to ensure index 0 is the current version
  const sortedVersions = [...versions].sort((a, b) => {
    const timeA = new Date(a.timestamp).getTime();
    const timeB = new Date(b.timestamp).getTime();
    return timeB - timeA; // DESC order
  });

  return sortedVersions.map((version, index) => ({
    ...version,
    isCurrentVersion: index === 0,
    editorName: version.editor.email || version.editor.username,
    published: formatWrittenDate(version.timestamp),
  }));
};
